const SET_CURRENT_USER = 'alerts/SET_CURRENT_USER';
const SET_APP_MENU = 'alerts/SET_APP_MENU';
const SET_BASE_URL = 'SET_BASE_URL'
const SET_MYKOMATSU_BASE_URL = 'SET_MYKOMATSU_BASE_URL'
const SET_CART_COUNT = 'SET_CART_COUNT'
const SET_MYKOMATSU_REGION = 'SET_MYKOMATSU_REGION'
const SET_KOMATSU_CARE_BROCHURES = 'SET_KOMATSU_CARE_BROCHURES'
const SET_MAP_CENTER = 'SET_MAP_CENTER'
const SET_APP_LINK = 'alerts/SET_APP_LINK';
const SET_IS_MINEXPO_ENABLED = 'SET_IS_MINEXPO_ENABLED'

export {
    SET_CURRENT_USER, SET_APP_MENU, SET_BASE_URL, SET_MYKOMATSU_BASE_URL, SET_CART_COUNT,
    SET_MYKOMATSU_REGION, SET_KOMATSU_CARE_BROCHURES, SET_MAP_CENTER, SET_APP_LINK, SET_IS_MINEXPO_ENABLED
};